import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import PageHeader from '@spark/ui-components/components/BreadCrumb';
import OuvidoriaCard from './components/OuvidoriaCard';

const OuvidoriaMain = () => (
  <Container fluid>
    <Row>
      <Col md={12}>
        <PageHeader
          title=""
          routeSegments={[
            { name: 'Inicio' },
            { name: 'Ouvidoria' },
          ]}
        />
      </Col>
    </Row>

    <Row>
      <Col md={12}>
        <OuvidoriaCard />
      </Col>
    </Row>
  </Container>
);

export default OuvidoriaMain;
